/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

// background colors are edited directly on the html component
export const defaultNavigation: FuseNavigationItem[] =
[
    {
        id   : 'home',
        title: 'Home',
        type : 'basic',
        externalLink: false,
        link: 'home',
        classes:
        {
            wrapper: "my-8 mx-0",
            title: "text-white text-lg"
        },
    },
    {
        id   : 'products',
        title: 'Products',
        type : 'collapsable',
        externalLink: false,
        classes:
        {
            wrapper:"bg-primary m-0 border-0",
            title: "text-white text-lg"
        },
        children:
        [
            { title: 'Product Overview', type : 'basic', link:'/product-overview', classes:{
                title: "md:text-black lg:text-black text-white font-bold ",  
            }},
            { title: 'Fibre', type : 'basic', link:'/products/fibre', classes:{
                title: "md:text-black lg:text-black text-white font-bold ",
            }},
            { title: '5G', type : 'basic', link:'/products/5G', classes:{
                title: "md:text-black lg:text-black text-white font-bold ", 
            }},
            // { title: 'AirFibre', type : 'basic',link:'/products/airfibre', classes:{
            //     title: "md:text-black lg:text-black text-white font-bold ",  
            // }},
            ],
    },
    {
        id   : 'support',
        title: 'FAQ',
        type : 'basic',
        externalLink: false,
        link: '/support',
        classes:
        {
            wrapper: "mt-8 mb-4 mx-0",
            title: "text-white text-lg"
        },
    },
    // {
    //     id   : 'blog',
    //     title: 'Blog',
    //     type : 'basic',
    //     externalLink: true,
    //     link: '/blogs',
    //     classes:
    //     {
    //         wrapper: "my-4 mx-0",
    //         title: "text-white text-lg"
    //     },
    // },
    // {
    //     id   : 'blog',
    //     title: 'Blog',
    //     type : 'basic',
    //     externalLink: true,
    //     link: '/blogs',
    //     classes:
    //     {
    //         wrapper: "my-4 mx-0",
    //         title: "text-white text-lg"
    //     },
    // },
    {
        id   : 'deals',
        title: 'Deals',
        type : 'basic',
        externalLink: false,
        link: '/deals',
        classes:
        {
           wrapper: "my-4 mx-0",
           title: "text-white text-lg"
        },
    },
    {
        id   : 'about',
        title: 'About-Us',
        type : 'basic',
        externalLink: false,
        link: '/about-us',
        classes:
        {
           wrapper: "my-4 mx-0",
           title: "text-white text-lg"
        },
    },
    {
        id   : 'contact',
        title: 'Contact Us',
        type : 'basic',
        externalLink: false,
        link: 'contact-us',
        classes:
        {
            wrapper: "my-4 mx-0",
            title: "text-white text-lg"
        },
    }    
];

export const horizontalNavigationLoggedIn: FuseNavigationItem[] =
[
    {
        id   : 'home',
        title: 'Home',
        type : 'basic',
        externalLink: false,
        link: 'home',
        classes:
        {
            wrapper:'rounded-full background-button-white',
            title:"  text-lg"
        },
    },
    {
        id   : 'products',
        title: 'Products',
        type : 'group',
        externalLink: false,
        icon:'arrow_drop_down',
        classes:
        {
            wrapper:'rounded-full background-button-white',
            title:"  text-lg"
        }
        ,children:
        [
            { title: 'Product Overview', type : 'basic', link:'/product-overview', classes:{
                title: "text-white font-bold ",  
            }},
            { title: 'Fibre', type : 'basic', link:'/products/fibre', classes:{
                title: "text-white font-bold", 
            }},
            { title: '5G', type : 'basic', link:'/products/5G', classes:{
                title: "text-white font-bold",  
            }},
            // { title: 'AirFibre', type : 'basic',link:'/products/airfibre', classes:{
            //     title: "text-white font-bold",   
            // }},

        ]
    },
    // {
    //     id   : 'deals',
    //     title: 'Deals',
    //     type : 'basic',
    //     externalLink: false,
    //     link: '',
    //     classes:
    //     {
    //         wrapper:'rounded-full background-button-white',
    //         title:"  text-lg"
    //     }
    // },
    {
        id   : 'deals',
        title: 'Deals',
        type : 'basic',
        externalLink: false,
        link: 'deals',
        classes:
        {
            wrapper:'rounded-full background-button-white',
            title:"  text-lg"
        },
    },
    // {
    //     id   : 'blog',
    //     title: 'Blog',
    //     type : 'basic',
    //     externalLink: false,
    //     link: 'blogs',
    //     classes:
    //     {
    //         wrapper:'rounded-full',
    //         title:"  text-lg"
    //     },
    // },   
    {
        id   : '',
        title: 'About Us',
        type : 'basic',
        externalLink: false,
        link: 'about-us',
        // icon:'arrow_drop_down',
        classes:
        {
            wrapper:'rounded-full background-button-white',
            title:"  text-lg"
        }
        // ,children:
        // [
        //     { title: 'About us', type : 'basic', link: 'about-us' },
        //     // { title: 'Blogs', type : 'basic', link: 'blogs'  },
        // ]
    },
    {
        id   : '',
        title: 'FAQ',
        type : 'basic',
        externalLink: false,
        link: 'support',
        // icon:'arrow_drop_down',
        classes:
        {
            wrapper:'rounded-full background-button-white',
            title:"  text-lg"
        },
        // children:
        // [
        //     { title: 'Client care', type : 'basic', link: 'support' },
        //     // { title: 'WhatsApp Support', type : 'basic', link: 'dashboard'  },
        //     // { title: 'Speed test', type : 'basic', link: 'dashboard'  },
        //     // { title: 'Network status', type : 'basic', link: 'network'  },
        //     { title: 'Product information', type : 'basic', link: 'product-overview' },
        //     // { title: 'General FAQ', type : 'basic', link: 'faq' },
        //     // { title: 'Loading shedding', type : 'basic', link: 'support/96' },
        //     // { title: 'Product setup guides', type : 'basic', link: 'support/99' },
        // ]
    },
    {
        id   : 'contact',
        title: 'Contact Us',
        type : 'basic',
        externalLink: false,
        link: 'contact-us',
        classes:
        {
            wrapper:'rounded-full background-button-white',
            title:"  text-lg"
        },
    },
    {
        id   : 'checkCoverage',
        title: 'Check coverage',
        type : 'basic',
        externalLink: false,
        // link: 'home', // Removed 15/07/25 for updates to coverage modal component
        classes:
        {
            icon: "font-bold",
            wrapper:"rounded-full bg-accent text-brown-600 hover:bg-secondary-600 font-bold transition-all duration-800 ease-in-out delay-500 opacity-100 translate-y-0 group-[.show-coverage]:opacity-0 group-[.show-coverage]:translate-y-2",
            title:"font-bold text-lg",
            subtitle:""
        },
        hidden: () => false
    },

    // {
    //     id   : 'blog',
    //     title: 'Blog',
    //     type : 'basic',
    //     externalLink: false,
    //     link: 'blogs',
    //     classes:
    //     {
    //         wrapper:'rounded-full',
    //         title:"  text-lg"
    //     },
    // },

];

export const defaultNavigationLoggedIn: FuseNavigationItem[] = [
        {
            id   : 'home',
            title: 'HOME',
            type : 'collapsable',
            externalLink: false,
            classes:
            {
                wrapper: "my-2 mx-0 rounded bg-primary",
                title: "text-white text-md",
                icon: "text-white"
            }
            ,children:
            [
                { title: 'Products', type : 'collapsable', children:[
                    { title: 'Product Overview', type : 'basic', link:'/product-overview', classes:{
                        title: "text-white font-bold ",  
                    }},
                    { title: 'Fibre', type : 'basic', link:'/products/fibre', classes:{
                        title: "text-white font-bold", 
                    }},
                    { title: '5G', type : 'basic', link:'/products/5G', classes:{
                        title: "text-white font-bold",  
                    }},
                    // { title: 'AirFibre', type : 'basic',link:'/products/airfibre', classes:{
                    //     title: "text-white font-bold",   
                    // }},
                ],classes:{
                    title: "text-white font-bold",   
                }},
                { title: 'Deals', type : 'basic', link:'/deals',  classes:{
                    title: "text-white font-bold",   
                }},
                { title: 'About Us', type : 'basic', link:'/about-us',  classes:{
                    title: "text-white font-bold",   
                }},
                { title: 'FAQ', type : 'basic', link:'/support',  classes:{
                    title: "text-white font-bold",   
                }},
                { title: 'Contact Us', type : 'basic', link:'/contact-us',  classes:{
                    title: "text-white font-bold",   
                }},
              
            ]
        },
        {
            id   : 'dashboard',
            title: 'DASHBOARD',
            type : 'collapsable',
            externalLink: false,
            classes:
            {
                wrapper: "my-2 mx-0 rounded bg-primary",
                title: "text-white text-md",
                icon: "text-white"
            }
            ,children:
            [
                { title: 'My Profile', type : 'basic', link:'/dashboard/profile',  classes:{
                    title: "text-white font-bold",   
                }},
               
                { title: 'My Requests', type : 'basic', link:'/dashboard/requests',  classes:{
                    title: "text-white font-bold",   
                }},

                { title: 'My Services', type : 'basic', link:'/dashboard',  classes:{
                    title: "text-white font-bold",   
                }},

                // { title: 'Payment Methods', type : 'basic', link:'/dashboard/profile',  classes:{
                //     title: "text-white font-bold",   
                // }},

                { title: 'Billing', type : 'collapsable', link:'/dashboard/invoices', 
                    classes:{
                        title: "text-white font-bold",
                    },
                    children:[
                        { title: 'Billing', type : 'basic', link:'/dashboard/invoices', queryParams: { segment: 'billing'}, classes:{
                            title: "text-white font-bold ",  
                        }},
                        { title: 'Statements', type : 'basic', link:'/dashboard/invoices', queryParams: { segment: 'statements'}, classes:{
                            title: "text-white font-bold", 
                        }},
                        { title: 'Invoices', type : 'basic', link:'dashboard/invoices', queryParams: { segment: 'invoices'}, classes:{
                            title: "text-white font-bold",  
                        }},
                        { title: 'Balances', type : 'basic', link:'/balances', classes:{
                            title: "text-white font-bold",  
                        }}
                    ],
                },
              
            ]
        },
];

export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
